export const FLAGS: Record<string, string> = {
  MEX: '🇲🇽', RSA: '🇿🇦', KOR: '🇰🇷', CZE: '🇨🇿', CAN: '🇨🇦', BIH: '🇧🇦',
  QAT: '🇶🇦', SUI: '🇨🇭', BRA: '🇧🇷', MAR: '🇲🇦', HAI: '🇭🇹', SCO: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  USA: '🇺🇸', PAR: '🇵🇾', AUS: '🇦🇺', TUR: '🇹🇷', GER: '🇩🇪', CUW: '🇨🇼',
  CIV: '🇨🇮', ECU: '🇪🇨', NED: '🇳🇱', JPN: '🇯🇵', SWE: '🇸🇪', TUN: '🇹🇳',
  BEL: '🇧🇪', EGY: '🇪🇬', IRN: '🇮🇷', NZL: '🇳🇿', ESP: '🇪🇸', CPV: '🇨🇻',
  KSA: '🇸🇦', URU: '🇺🇾', FRA: '🇫🇷', SEN: '🇸🇳', IRQ: '🇮🇶', NOR: '🇳🇴',
  ARG: '🇦🇷', ALG: '🇩🇿', AUT: '🇦🇹', JOR: '🇯🇴', POR: '🇵🇹', COD: '🇨🇩',
  UZB: '🇺🇿', COL: '🇨🇴', ENG: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', CRO: '🇭🇷', GHA: '🇬🇭', PAN: '🇵🇦',
};

export function flag(code: string): string {
  return FLAGS[code] ?? '🏳';
}

export const CONFED: Record<string, string> = {
  MEX: 'CONCACAF', CAN: 'CONCACAF', USA: 'CONCACAF', CRC: 'CONCACAF',
  PAN: 'CONCACAF', HON: 'CONCACAF', HAI: 'CONCACAF', CUW: 'CONCACAF',
  ARG: 'CONMEBOL', BRA: 'CONMEBOL', COL: 'CONMEBOL', URU: 'CONMEBOL',
  PAR: 'CONMEBOL', ECU: 'CONMEBOL', CHI: 'CONMEBOL', PER: 'CONMEBOL', BOL: 'CONMEBOL',
  NZL: 'OFC',
  KOR: 'AFC', JPN: 'AFC', AUS: 'AFC', IRN: 'AFC', KSA: 'AFC',
  QAT: 'AFC', IRQ: 'AFC', UZB: 'AFC', JOR: 'AFC',
  RSA: 'CAF', MAR: 'CAF', SEN: 'CAF', EGY: 'CAF', CIV: 'CAF',
  GHA: 'CAF', TUN: 'CAF', ALG: 'CAF', COD: 'CAF', CPV: 'CAF',
  CZE: 'UEFA', BIH: 'UEFA', SUI: 'UEFA', SCO: 'UEFA', TUR: 'UEFA',
  GER: 'UEFA', NED: 'UEFA', SWE: 'UEFA', BEL: 'UEFA', NOR: 'UEFA',
  AUT: 'UEFA', POR: 'UEFA', ENG: 'UEFA', CRO: 'UEFA', ESP: 'UEFA', FRA: 'UEFA',
};

export function confed(code: string): string {
  return CONFED[code] ?? '–';
}
